export default __webpack_public_path__ + "static/media/java-icon.ff6cb4bd.svg";